<div class="page">
    <div class="title">
        <div class="titleValue">{{ "appointments.title" | transloco }}</div>
        <div class="line"></div>
    </div>
    <div class="casos" *ngIf="citas.length > 0">
        <div class="casosList" *ngFor="let cita of citas">
            <div class="casosCard">
                <div class="infoLabel">{{ "appointments.issueNumber" | transloco }}: <div style="font-weight: 600;">{{cita?.ticket?.ID}}</div>
                </div>
                <div class="infoLabel">{{ "appointments.date" | transloco }}: <div style="font-weight: 600;">{{formatFecha(cita?.fecha_cita)}}</div>
                </div>
                <div class="infoLabel">{{ "appointments.technician" | transloco }}: <div style="font-weight: 600;">{{cita?.tecnico?.displayName}}</div>
                </div>
                <div class="infoLabel">{{ "appointments.address" | transloco }}: <div style="font-weight: 600;">{{cita?.end_point}}</div>
                </div>
                <div class="infoLabel">{{ "appointments.status" | transloco }}: <div style="font-weight: 600;">{{cita?.estadoCita?.estado}}</div>
                </div>
                <div class="infoLabel">{{ "appointments.comment" | transloco }}: <div style="font-weight: 600;">{{cita?.comentario}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="casos" *ngIf="!(citas.length > 0)">
        {{ "appointments.noAppointments" | transloco }}
    </div>
</div>
